// @flow

import React from 'react';
import KeepeekMedia from '../../../common/KeepeekMedia';
import type { MarketingTemplate } from '../../../../types/marketingType';

type Props = {
  data: MarketingTemplate
}

function FullContentNumbers({ data }: Props) {
  return (
    <div className="fullcontent-number-container">
      <div className="title">
        {data.title}
      </div>
      <div className="side-image">
        <KeepeekMedia keepeekId={data.sideImage.keepeekId} />
      </div>
      <div className="description">
        {data.description}
      </div>
      {
        data.marketingMainNumbers.length > 0 && (
          <div className="number-container">
            {
              data.marketingMainNumbers
                .sort((a, b) => a.position - b.position)
                .map(number => (
                  <div key={number.id} className="number">
                    <div className="number-value">
                      {number.value}
                    </div>
                    <div className="number-title">
                      {number.title}
                    </div>
                  </div>
                ))
            }
          </div>
        )}
    </div>
  );
}

export default FullContentNumbers;
